const UPDATE_CHECK_INTERVAL_MS = 60_000;

export function keepPwaUpdated(): void {
  if (!('serviceWorker' in navigator)) return;

  let refreshing = false;
  const watchedRegistrations = new WeakSet<ServiceWorkerRegistration>();

  const activateWaitingWorker = (registration: ServiceWorkerRegistration | undefined) => {
    if (!registration?.waiting) return;
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  const watchRegistration = (registration: ServiceWorkerRegistration | undefined) => {
    if (!registration || watchedRegistrations.has(registration)) return;
    watchedRegistrations.add(registration);
    activateWaitingWorker(registration);

    registration.addEventListener('updatefound', () => {
      const worker = registration.installing;
      if (!worker) return;
      worker.addEventListener('statechange', () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) {
          activateWaitingWorker(registration);
        }
      });
    });
  };

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  const checkForUpdate = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    watchRegistration(registration);
    const updatedRegistration = await registration?.update();
    watchRegistration(updatedRegistration);
    activateWaitingWorker(updatedRegistration ?? registration);
  };

  window.addEventListener('load', () => {
    void checkForUpdate().catch(() => undefined);
  });

  window.addEventListener('focus', () => {
    void checkForUpdate().catch(() => undefined);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkForUpdate().catch(() => undefined);
    }
  });

  window.setInterval(() => {
    if (document.visibilityState === 'visible') {
      void checkForUpdate().catch(() => undefined);
    }
  }, UPDATE_CHECK_INTERVAL_MS);
}
